'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * PhoenixQuoteMediaEarningCalendar is a web component
     * responsible for loading calculator on Quote Page
     *
     * @example
     *  <phoenix-quote-media-earning-calendar>
     *  </phoenix-quote-media-earning-calendar>
     */
    class PhoenixQuoteMediaEarningCalendar extends pageClass.PhoenixElement {
        // web component life cycle hook
        connectedCallback() {
            super.connectedCallback();
            const earningConfig = {
                lang: 'en',
                limit: 500,
                allExchangesInSelect: false,
                exchangeEnabled: true,
                calendarEnabled: true,
                dateRowEnabled: true,
                datePickerFormat: 'Y-m-d',
                resultsPerPage: 10,
                colVisible: 'true,true,true,true,true,true,false,true,true',
                symbolForwardURL: 'https://www.thestreet.com/quote/',
                longNameForwardURL: 'https://www.thestreet.com/quote/',
            };
            this._render(earningConfig);
        }

        _render(earningConfig) {
            let qmodConfig = JSON.stringify(earningConfig);
            this.innerHTML = `<div data-qmod-tool="earningscalendar"
            data-qmod-params=${qmodConfig} class="qtool has-forwardurl"></div>`;
        }
    }

    window.customElements.define('phoenix-quote-media-earning-calendar', PhoenixQuoteMediaEarningCalendar);
});
